import { React, useEffect, useState } from "react";
import axios from 'axios'
import { serverUrl } from '../../../Constant/Static/config';
import './PaymentReceipt.css';
// import Applicant_Details from "../Applicant_Details/Appilicant_Details";




function PaymentRecipt() {

    const [data, setData] = useState([]);
    const [anum, setanum] = useState('');
    const [errors, seterror] = useState({})
    const [csrfToken, setCsrfToken] = useState('');

    const handleOnChange = (e) => {
        setanum(e.target.value);

    }
    const validate = (anum) => {
        const error = {};
        if (!anum) {
            error.Application_number = "Enter the Application Number"
        }
        else if (anum.length != 7) {
            error.Application_number = "Invalid Application Number"

        }
        return error;

    }
    const handleSubmit = async (e) => {

        e.preventDefault();
        setData([])
        const errors = validate(anum) || {};
        seterror(errors)

        if (Object.keys(errors).length === 0) {


            try {
                const res = await axios.post(`${serverUrl}/api/admin/get_pay_details`, { app_no: anum }, {
                    headers: {
                        'Content-Type': 'application/json',
                        'CSRF-Token': csrfToken,
                    },
                    withCredentials: true,
                }

                )
                // console.log(res.status)
                // if(res.status==400){
                //     // console.log("ihjjdijhi")
                //     seterror({Application_number:'The above applicant is not involved in payment process'})
                // }
                //// console.log(res.data.result);
                setData(res.data.result)
            }
            catch (error) {
                if (error.response && error.response.status === 400) {
                    seterror({ Application_number: 'The above applicant is not involved in payment process' });
                } else {
                    console.error('Unexpected error:', error);
                }
            }
        }
    }

    const handleDownload = async (trans_id) => {
        // console.log(trans_id);

        try {
            const res = await axios.post(`${serverUrl}/api/admin/app_reciptpdf`, { transactionId: trans_id, appno: anum }, {
                responseType: 'blob'

            })
            const url = window.URL.createObjectURL(res.data);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${anum}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url)
        }
        catch (err) {
            // console.log(err);
        }


    }
    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);

            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);
    return (
        <>
            <h1>Payment Receipt</h1>
            <div className="payment_receipt_container">

                <div className="Applicant_Details_container">
                    <form onSubmit={handleSubmit}>
                        <input id="Application_number" name="Application_number" onChange={handleOnChange} value={anum}></input>
                        <button id="Showbutton" type="submit" onClick={handleSubmit}>Show</button>
                    </form>

                </div>
                {data.length != 0 ? (
                    data.map((item, index) => {
                        return (
                            item.TRANS_ID !== null && (<div className="payment_receipt_row_continer">
                                <p>Download Payment Receipt {index + 1}</p>
                                <button onClick={() => { handleDownload(item.TRANS_ID) }} id="payment_recipt_download_button">Download</button>
                            </div>)

                        )
                    })
                ) : (errors.Application_number && (<p className="error_message">{errors.Application_number}</p>)

                )
                }
            </div>
        </>
    )
}

export default PaymentRecipt;